import { Box, Chip, Stack, Typography } from "@mui/material";
import { fullName } from "../../utils/formatting";

export default function AdminProfileSettings({ adminProfile }) {
  const teamNames = Array.from(
    new Set(
      adminProfile.roles
        .filter(({ team }) => !!team)
        .map(({ team }) => team.title)
    )
  );
  return (
    <Box>
      <Typography variant="body1" fontWeight={"bold"}>
        Employee Profile
      </Typography>
      <Stack
        direction={"row"}
        gap={1}
        flexWrap={"wrap"}
        justifyContent={"flex-start"}
      >
        {adminProfile.manager && adminProfile.manager.user && (
          <Box>
            <Typography variant="overline">Manager</Typography>
            <Box>
              <Chip label={fullName(adminProfile.manager.user)} size="small" />
            </Box>
          </Box>
        )}
        <Box>
          <Typography variant="overline">
            Team{teamNames.length == 1 ? "" : "s"}
          </Typography>
          <Stack direction={"row"} spacing={1}>
            {teamNames.map((teamName, i) => (
              <Chip label={teamName} key={i} size="small" />
            ))}
          </Stack>
        </Box>
        <Box>
          <Typography variant="overline">
            Role{adminProfile.roles.length == 1 ? "" : "s"}
          </Typography>
          <Stack direction={"row"} spacing={1}>
            {adminProfile.roles.map((role, i) => (
              <Chip label={role?.title} key={i} size="small" />
            ))}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
